import { useMemo } from 'react';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';

import { sanitizeHtml } from '@e-socna/sanitize-html';
import { EMPTY_OBJECT, EMPTY_STRING } from '@e-socna/empty';

import { environment } from '../environment';
import { useFileReadContext } from '../contexts/FileReadContext';
import { withFileReadContext } from '../utils/with-file-read-context.util';

interface Props {
  readonly className?: string;
  readonly html?: string | null;
  readonly sx?: SxProps<Theme>;
}

export const HtmlViewer = ({ sx, html, className }: Readonly<Props>) => {
  const fileReadContext = useFileReadContext();
  const safeHtml = useMemo(
    () =>
      html
        ? withFileReadContext({
            html: sanitizeHtml(html),
            context: fileReadContext,
            backendUrl: environment.backendUrl,
          })
        : EMPTY_STRING,
    [html, fileReadContext],
  );

  return (
    <Box
      // eslint-disable-next-line react/forbid-component-props
      className={className}
      dangerouslySetInnerHTML={{
        __html: safeHtml,
      }}
      sx={{
        margin: 0,
        padding: 2,
        border: (theme: Readonly<Theme>) =>
          `${theme.palette.grey[200]} 5px solid`,
        borderRadius: '8px',
        backgroundColor: 'white',
        color: 'black',
        ...(sx ?? EMPTY_OBJECT),
      }}
    />
  );
};
